export enum RegisterFormFields {
    FirstName = 'first_name',
    LastName = 'last_name',
    Email = 'email',
    Password = 'password',
    ConfirmPassword = 'confirm_password',
}